import { createContext } from "react";

const PoliticSpaceContext = createContext();

export default PoliticSpaceContext;
